import { Link } from 'react-router-dom';
import { getRecentArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function ArticleList() {
  const recentArticles = getRecentArticles(4);

  return (
    <section className="py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">最新资讯推荐</h2>
            <p className="mt-2 text-foreground-500 text-sm">韩漫推荐、阅读指南、作品分析等精彩内容</p>
          </div>
          <Link
            to="/category/mianfei-wuzhe"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            更多文章 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {recentArticles.map((article) => (
            <ArticleCard key={article.id} article={article} variant="horizontal" />
          ))}
        </div>
      </div>
    </section>
  );
}